import { AppModal } from '@/components/AppModal'

interface ForgotPasswordModalProps {
  show: boolean
  email: string
  onEmailChange: (value: string) => void
  onSubmit: (e: React.FormEvent) => void
  onClose: () => void
  isLoading: boolean
  success: boolean
  error: string | null
}

function ForgotPasswordModal({
  show,
  email,
  onEmailChange,
  onSubmit,
  onClose,
  isLoading,
  success,
  error,
}: ForgotPasswordModalProps) {
  if (!show) return null

  return (
    <AppModal
      isOpen={show}
      onClose={onClose}
      title={success ? 'パスワード再設定メールを送信しました' : 'パスワードの再設定'}
      maxWidth={440}
    >
      {success ? (
        <>
          <p className="forgot-password-modal__success">
            ご登録のメールアドレス宛に、パスワード再設定用のリンクをお送りしました。
            <br />
            メールをご確認のうえ、パスワードを再設定してください。
          </p>
          <div className="app-modal__actions">
            <button type="button" onClick={onClose} className="editable-field-button">
              閉じる
            </button>
          </div>
        </>
      ) : (
        <form id="forgot-password-form" onSubmit={onSubmit}>
          <p className="forgot-password-modal__description">
            メールアドレスを入力してください。
            <br />
            ご入力いただいたアドレスが登録されている場合、パスワード再設定用のリンクをお送りします。
          </p>
          <div className={`form-group ${error ? 'has-error' : ''}`}>
            <label htmlFor="forgot-password-email">メールアドレス</label>
            <input
              id="forgot-password-email"
              type="email"
              value={email}
              onChange={(e) => onEmailChange(e.target.value)}
              placeholder="example@irogami.com"
              autoComplete="email"
              className={error ? 'error' : ''}
              disabled={isLoading}
            />
            {error && (
              <div className="field-error">
                <i className="bi bi-exclamation-circle"></i>
                <span>{error}</span>
              </div>
            )}
          </div>
          <div className="app-modal__actions">
            <button type="button" onClick={onClose} className="editable-field-button cancel" disabled={isLoading}>
              キャンセル
            </button>
            <button
              type="submit"
              form="forgot-password-form"
              className="editable-field-button primary"
              disabled={isLoading}
            >
              {isLoading ? '送信中...' : '送信'}
            </button>
          </div>
        </form>
      )}
    </AppModal>
  )
}

export default ForgotPasswordModal
